@if (visible$()) {
  <ng-content></ng-content>
}
